export class ButtonVisibility {
  public buttonId: string;
  public isVisible: boolean;
  public title: string;
}

export enum ButtonsIDEnum {
  "GROUP" = "group",
  "UNGROUP" = "ungroup",
  "SEND_TO" = "sendTO",
  "SEND_PB" = "sendPB",
  "CANCEL_TO" = "cancelTO",
  "CANCEL_PB" = "cancelPB",
  "START_WIZARD" = "startWizard",
  "RESEND_TO" = "resendTO",
  "UNPLAN_PB" = "unplanPB",
  "UNPLAN_TO" = "unplanTO",
  "RECALCULATE_TO" = "recalculateTO",
  "ADD_REMINDER" = "addReminder"

}
